import type { ScheduledMeeting } from '../../../contexts';
import { useUserPermissions } from '../../../contexts/UserPermissionsContext';
import useScheduleLimits from './useScheduleLimits';

const useMeetingPermissions = (personalMeetings: ScheduledMeeting[]) => {
  const { isSuccess: permissionsReady, userPermissions } = useUserPermissions();
  const { maxPersonalMeetings, isLoading: limitsLoading } = useScheduleLimits();

  const canCreateMore = personalMeetings.length < maxPersonalMeetings;
  const isFreePlan = userPermissions.license?.license_type === 'free';

  return {
    apiReady: permissionsReady && !limitsLoading,
    canCreateMore,
    isFreePlan,
    creationLimit: {
      max: maxPersonalMeetings,
      remaining: Math.max(maxPersonalMeetings - personalMeetings.length, 0),
    },
    permissions: userPermissions,
  };
};

export default useMeetingPermissions;
